import * as Api from '@ViewModels';
import React from 'react';

interface UseFieldTypeChangeProps {
	field: Api.IFormField<string>;
	questionIndex: number;
	onUpdateField: (field: Api.IFormField<string>, index: number) => void;
	clearErrors: (name: any) => void;
}

export const useFieldTypeChange = ({ field, questionIndex, onUpdateField, clearErrors }: UseFieldTypeChangeProps) => {
	React.useEffect(() => {
		// if fieldType is multiple options or Option
		if (
			(field.fieldType === Api.FormFieldType.MultipleOptions || field.fieldType === Api.FormFieldType.Option) &&
			field?.options?.length === 0
		) {
			// Add two empty options with a label and the field id
			const updatedField = {
				...field,
				options: [
					{
						id: crypto.randomUUID(),
						label: '',
						fieldId: field.id,
					},
					{
						id: crypto.randomUUID(),
						label: '',
						fieldId: field.id,
					},
				] as Api.CustomFormFieldOption[],
			};
			onUpdateField(updatedField, questionIndex);
		}
		// String also normalizes missing options to [] on mount (useFieldStateManager relies on this); other types only
		// clear real leftovers so loading a survey doesn't rewrite every question.
		const isChoiceType =
			field.fieldType === Api.FormFieldType.MultipleOptions || field.fieldType === Api.FormFieldType.Option;
		const hasLeftoverOptions =
			field.fieldType === Api.FormFieldType.String ? field?.options?.length !== 0 : !!field?.options?.length;
		if (!isChoiceType && hasLeftoverOptions) {
			const updatedField = {
				...field,
				options: [] as Api.CustomFormFieldOption[],
			};
			clearErrors(`customForm.fields.${questionIndex}.options`);
			onUpdateField(updatedField, questionIndex);
		}
	}, [clearErrors, field, onUpdateField, questionIndex]);
};
